export const UPLOAD_SECTION_ID = "uploadSection"
export const LOGO_IMG_ID = "logoImg"
export const SHADOW_OVERLAY_ID = "shadowOverlay"
export const CANVAS_WIDTH = 1300
export const CANVAS_HEIGHT = 820

export const UPLOAD_BOX_OPTIONS = {
  id: UPLOAD_SECTION_ID,
  hoverCursor: "pointer",
  hasControls: false,
  selectable: false,
  scaleY: 0.344045368620038,
  scaleX: 0.344045368620038,
  left: 512.4744801512288,
  top: 451.5255198487712,
}
export const PLACEHOLDER_PATH_OPTIONS = {
  hasControls: true,
  selectable: true,
  moveCursor: true,
  objectCaching: true,
  absolutePositioned: true,
  stroke: "red",
  fill: "rgba(0,0,0,0)",
  scaleY: 0.4332176372284354,
  scaleX: 0.43370059835004454,
  left: 259,
  top: 329,
}

export const SHADOW_OVERLAY = {
  ...PLACEHOLDER_PATH_OPTIONS,
  id: SHADOW_OVERLAY_ID,
  hasControls: false,
  selectable: false,
  moveCursor: false,
  left: 255,
  // top: 329,
}

export const UPLOAD_IMG_OPTIONS = {
  ...UPLOAD_BOX_OPTIONS,
  id: LOGO_IMG_ID,
  hasControls: true,
  selectable: true,
  moveCursor: true,
}

export const CANVAS_CONFIG = {
  width: CANVAS_WIDTH,
  height: CANVAS_HEIGHT,
  preserveObjectStacking: true,
  controlsAboveOverlay: true,
  selection: false,
  hasControls: false,
  moveCursor: false,
  backgroundVpt: false,
}
